import React, { Component } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  withTheme,
} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PeopleIcon from "@material-ui/icons/People";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import SendIcon from "@material-ui/icons/Send";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import CancelIcon from '@material-ui/icons/Cancel';
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import { auth, db, storageRef } from "../../service/firebase";
import { setChatType } from "../../redux/actions/appActions";
import {logError } from "../../helpers/auth";
import AttachmentIcon from '@material-ui/icons/Attachment';
import ApiServices from "../../api/api";
import { signup, signin, signInAnonymously } from "../../helpers/auth";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

class ServicesChatWindow extends Component {
  constructor(props) {
    super();
    this.state = {
      value: 0,
      applicantObj: {},
      adminId: 1,
      firebaseuser: auth().currentUser,
      user: JSON.parse(localStorage.getItem("obj")),
      chatType: 'peer',
      chats: [],
      content: "",
      readError: null,
      writeError: null,
      loadingChats: false,
      authenticated: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
    this.handleImageAsFile = this.handleImageAsFile.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
    this.myRef = React.createRef();
  }

  componentDidMount() {

    if (!this.props.location.state) {
      this.props.history.goBack();
    } else {
      this.getAdminId()
      this.setState({
        firebaseuser: this.props.location.state.userObj
      })
      //this.setChatArea(this.props.location.state.userObj.uid, this.state.adminId);
    }
    // this.updateChatProfile();
  }

  componentWillUnmount() {
    this.setState({
      chats: []
    })
  }

  updateChatProfile(){
    var loggedinnameonly = localStorage.getItem("loggedinname");
    var loggedinname = localStorage.getItem("loggedinname");
    let user = auth().currentUser;
    if (user != null) {
      
    }else{
      if(loggedinname){
        // create a valid email for firebase login if user is using id
        if(loggedinname.indexOf('@') == -1){
          loggedinname = loggedinname + '@myrights.com';
          if(loggedinname.indexOf(' ') != -1){
            loggedinname = loggedinname.split(' ').join('_');
          }
        }
        signin(loggedinname, localStorage.getItem("loggedinpass"))
          .then((userCredential) => {
            console.log("userCredential", userCredential)
            // Signed in 
            var user = userCredential.user;
            user.updateProfile({
              displayName: loggedinnameonly,
            })
            // ...
          })
          .catch((error) => {
            console.log("error", error)
            var errorCode = error.code;
            var errorMessage = error.message;
            // ..
          });
      }else{
        signInAnonymously()
        .then((res) => {
          auth().onAuthStateChanged((user) => {
            console.log("onAuthStateChanged>>", user);
            if (user) {
              user.updateProfile({
                displayName: this.state.name ? this.state.name : loggedinnameonly,
              })
                .then(function (res) {
                  console.log("updateProfile res>>", res);
                })
                .catch(function (error) {
                  // An error happened.
                  console.log("updateProfile error>>", error);
                });
            } else {
              console.log("error>>", user);
            }
          });
        })
        .catch((err) => console.log("err>>>", err));
      }
    }
  }

  getAdminId() {
    var params = {
      "communityId": this.props.communityuid,
      "roleType": ["Admin"]
    }
    ApiServices.getApplicantList(params).then((res) => {
      try {
        if (res.data.status == 200) {
          var adminid = res.data.data[0].id
          this.setState({ adminId: adminid })
          this.setChatArea(this.props.location.state.userObj.uid, adminid);
        }
      } catch (err) {
        console.log("err::", err)
        var errorObj = {
          component: 'ServicesChatWindow',
          method: 'getAdminId',
          error: err
        }
        logError(errorObj);
      }
    });
  }

  setChatRoom(senderId, receiptId) {
    let { communityuid, chatConfig, location } = { ...this.props };
    let chatroom = `${communityuid}`;
    // var chatRefId = [location.state.caseObj.userId, location.state.caseObj.caseId, this.state.adminId].sort(function (a, b) {
    //   return a - b;
    // })
    var chatRefId = location.state.caseObj.caseId;
    return (chatroom = `${chatroom}/discussionboard/${chatRefId}`);
  }

  setChatArea(senderId, receiptId) {
    let { location } = { ...this.props };
    this.setState({ readError: null, loadingChats: true });
    const chatArea = this.myRef.current;
    try {
      let chatroom = this.setChatRoom(senderId, receiptId);
      console.log(chatroom)
      db.ref(chatroom).on("value", (snapshot) => {
        let chats = [];
        snapshot.forEach((snap) => {
          var chatNode = {};
          chatNode = snap.val();
          chatNode.key = snap.key;
          chats.push(chatNode);
        });
        chats.sort(function (a, b) {
          return a.timestamp - b.timestamp;
        });
        this.setState({
          chats,
          user: this.state.user,
        });
        if(chatArea){
          chatArea.scrollBy(0, chatArea.scrollHeight);
        }
        this.setState({ loadingChats: false });
      });
    } catch (error) {
      console.error(error);
      var errorObj = {
        component: 'ServicesChatWindow',
        method: 'setChatArea',
        error: error
      }
      logError(errorObj);
      this.setState({ readError: error.message, loadingChats: false });
    }
  }

  async handleTextAreaChange(event) {
    this.setState({
      content: event.target.value,
    });
  }

  // async deleteChat(params) {

  //   let myKey = params;
  //   let chatroom = this.setChatRoom(this.props.location.state.userObj.uid, this.props.location.state.applicant.id);
  //     // remove item from database
  //     let my_db_ref = db.ref(chatroom + '/' + myKey);

  //     my_db_ref.once('value', function(snapshot) {
  //       let myChatObj = {};
  //         myChatObj = snapshot.val();
  //         myChatObj.key = snapshot.key;
  //         myChatObj.archieve = true;
  //         console.log("myChatObj::", myChatObj);
  //         my_db_ref.set(myChatObj);
  //     });
  // }

  async handleSubmit(event) {
    let { userObj, location, fbuserObj, communityuid } = { ...this.props };

    event.preventDefault();
    if (this.state.content != '') {
      this.setState({ writeError: null });
      const chatArea = this.myRef.current;
      let adminUnreadCount = 1;
      try {
        let chatroom = this.setChatRoom(this.props.location.state.caseObj.userId, this.state.adminId);
        let data = {
          content: this.state.content,
          timestamp: Date.now(),
          fbuid: this.state.firebaseuser.uid,
          systemuid: '',
          name: this.state.firebaseuser.displayName,
          userid: JSON.parse(localStorage.getItem("obj")).userId,
          usertype: JSON.parse(localStorage.getItem("obj")).roleType,
          avatarurl: this.state.firebaseuser.photoURL,
          adminunread: adminUnreadCount
        };
        await db.ref(chatroom).push(data);
        let peerAlertData = {
          content: this.state.content,
          timestamp: Date.now(),
          userid: JSON.parse(localStorage.getItem("obj")).userId,
          name: location.state.userObj.displayName,
          caseId: location.state.caseObj.caseId
        }
        let adminchatroom = `${communityuid}`;
        await db.ref(adminchatroom + '/discussionboard/discussionalert').push(peerAlertData);

        this.setState({ content: "" });
        chatArea.scrollBy(0, chatArea.scrollHeight);
      } catch (error) {
        console.error(error);
        var errorObj = {
          component: 'ServicesChatWindow',
          method: 'handleSubmit',
          error: error
        }
        logError(errorObj);
        this.setState({ writeError: error.message });
      }
    }
  }

  handleLogout() {
    this.setState(
      {
        authenticated: false,
      },
      () => {
        auth().signOut();
      }
    );
  }

  formatTime(timestamp) {
    const d = new Date(timestamp);
    const time = `${d.getDate()}/${d.getMonth() + 1
      }/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`;
    return time;
  }

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
    });
  };

  handleChangeIndex = (index) => {
    this.setState({
      value: index,
    });
  };

  handleImageAsFile(e) {
    var that = this;
    if (e.target.files[0]) {
      const image = e.target.files[0];
      console.log(image)
      const uploadTask = storageRef.ref(`/images/${image.name}`).put(image)
      //initiates the firebase side uploading 
      uploadTask.on('state_changed', (snapShot) => {
        //takes a snap shot of the process as it is happening
        console.log(snapShot)
      }, (err) => {
        //catches the errors
        console.log(err)
      }, () => {
        // gets the functions from storage refences the image storage in firebase by the children
        // gets the download url then sets the image from firebase as the value for the imgUrl key:
        storageRef.ref('images').child(image.name).getDownloadURL().then(fireBaseUrl => {
          console.log(fireBaseUrl)
          that.handleImageUpload(fireBaseUrl)
          //setImageAsUrl(prevObject => ({...prevObject, imgUrl: fireBaseUrl}))
        })
      })
    }
  }

  async handleImageUpload(fireBaseUrl) {
    let { userObj, location, fbuserObj } = { ...this.props };
    this.setState({ writeError: null });
    const chatArea = this.myRef.current;
    try {
      let chatroom = this.setChatRoom(this.props.location.state.caseObj.userId, this.state.adminId);
      let data = {
        content: fireBaseUrl,
        type: "image",
        timestamp: Date.now(),
        fbuid: location.state.userObj.uid,
        systemuid: '',
        name: location.state.userObj.displayName,
        avatarurl: location.state.userObj.photoURL,
      };

      console.log("chatroom>>", chatroom, data);

      await db.ref(chatroom).push(data);
      this.setState({ content: "" });
      chatArea.scrollBy(0, chatArea.scrollHeight);

      if (location.state.chatType == 'peer') {
        // set parameters and then send notification: peer to peer
        var notiParmas = {
          to: location.state.applicant.fcmId,
          title: location.state.userObj.displayName ? location.state.userObj.displayName : JSON.parse(localStorage.getItem("obj")).userId,
          message: data.content,
          page: '/layout/chatwindow',
          applicant: { id: location.state.applicant.id },
          chatType: 'peer'
        }
        ApiServices.sendPushNotification(notiParmas);
      } else {
        // set paramenter and then send notification in group-chat
        var notiParmas = {
          to: "/topics/" + this.state.topic,
          title: location.state.applicant.id,
          message: data.content,
          page: 'groupchat',
          applicant: { id: location.state.applicant.id },
          chatType: 'group'
        }
        ApiServices.sendPushNotification(notiParmas);
      }

    } catch (error) {
      console.error(error);
      var errorObj = {
        component: 'ServicesChatWindow',
        method: 'handleImageUpload',
        error: error
      }
      logError(errorObj);
      this.setState({ writeError: error.message });
    }
  }

  render() {
    const { t } = this.props;
    const { classes, theme, chatConfig, location } = this.props;
    const roleId = JSON.parse(localStorage.getItem("obj")).roleId;
    const sentuserId = JSON.parse(localStorage.getItem("obj")).userId;
    var caseid = location.state.caseObj.caseId ? location.state.caseObj.caseId : '';
    const { templateID } = this.props;
    let bgStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    var username = location.state.userObj.displayName ? location.state.userObj.displayName : sentuserId
    return (
      <div className={classes.root + " ChatWindow getknowledgeable_page"}>

        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }

        {this.state.chatType == "group" && (
          <AppBar
            position="static"
            color="default"
            className="chatheader gktabs bgwhitetabs"
          >
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant=""
              className="chattabs"
              aria-label="full width tabs example"
            >
              <Tab icon={<QuestionAnswerIcon />} label="" {...a11yProps(0)} />
              <Tab icon={<PeopleIcon />} label="" {...a11yProps(1)} />
            </Tabs>
          </AppBar>
        )}

        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}
          className="infotabcontainer getaccesstabspage forum-chat-window"
        >
          <TabPanel className="chatmsglistholdermain" value={this.state.value} index={0} dir={theme.direction}>

            {
              templateID == 1 && (
                <Grid item xs={12}>
                  <Grid container spacing={3} className="gridcontainer border-bottom-grey white_bg border-topleftradius-10px border-toprightradius-10px">
                    <Grid item xs={2} className="text-center hospitaliconholder color-darkblue">
                      <AccountCircleIcon />
                    </Grid>
                    <Grid item xs={10} className="text-left">
                      <p className="forumtitle color-darkblue">{t('Case Discussion') + ': ' + caseid}</p>
                      {/* <p className="chatlastseeninfo">Last seen:23/03/21</p> */}
                    </Grid>
                  </Grid>
                </Grid>
              )
            }

            <div id="frame" className={this.state.chatType == "group" ? 'showgroupaction' : 'peeraction'}>
              <div class="content">
                <div class="messages" id="chatBox" ref={this.myRef}>
                  <ul >
                    {this.state && this.state.chats && this.state.chats.length == 0 ?
                      <div></div>
                      :
                      this.state.chats.map((chat) => {
                        return this.props.location.state.userObj.uid === chat.fbuid ? (
                          <li className={`sent ${chat.archieve ? "hide" : ""}`}>
                            <div class="msg-wrap">
                              <div class="msg">
                                {roleId == 2 ? (<span class="msg-del-btn" onClick={() => this.deleteChat(chat.key)}>{<CancelIcon />}</span>) : ''}
                                <div class="msg-info">{chat.name ? chat.name : localStorage.getItem("loggedinname")}</div>
                                <div class="msg-txt">
                                  {
                                    chat.type && chat.type == "image" ? (
                                      <img className="chatimag" src={chat.content} alt="image tag" />

                                    ) : (
                                      <span>{chat.content}</span>
                                    )
                                  }
                                </div>
                                <div class="chat-time">
                                  {this.formatTime(chat.timestamp)}
                                </div>
                              </div>
                            </div>
                          </li>
                        ) : (
                          <li className={`replies ${chat.archieve ? "hide" : ""}`}>
                            <div class="msg-wrap">
                              <div class="msg">
                                {roleId == 2 ? (<span class="msg-del-btn" onClick={() => this.deleteChat(chat.key)}>{<CancelIcon />}</span>) : ''}
                                <div class="msg-info">{"Admin"}</div>
                                <div class="msg-txt">
                                  {
                                    chat.type && chat.type == "image" ? (
                                      <img className="chatimag" src={chat.content} alt="image tag" />

                                    ) : (
                                      <span>{chat.content}</span>
                                    )
                                  }
                                </div>
                                <div class="chat-time">
                                  {this.formatTime(chat.timestamp)}
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="chatbtmmenu">
              {
                templateID == 1 ? (
                  <Grid item xs={12} className="text-center">
                    <Grid container spacing={3} className="gridcontainer border-top-grey white_bg border-bottomleftradius-10px border-bottomrightradius-10px">
                      <Grid item xs={2} className="text-center hospitaliconholder color-darkblue">
                        <Button
                          variant="contained"
                          component="label"
                          className="menubtn  chatgallerybutton"
                        >
                          <AttachmentIcon />
                          <input
                            onChange={this.handleImageAsFile}
                            type="file"
                            hidden
                          />
                        </Button>

                      </Grid>

                      <Grid item xs={8} className="text-left">
                        <p className="zero chatmsgtextboxholder">
                          <TextField
                            id="standard-basic"
                            label=""
                            placeholder={t("Type here")}
                            helperText=""
                            value={this.state.content}
                            onChange={this.handleTextAreaChange}
                            style={{ 'margin-left': '10px' }}
                          />
                        </p>
                      </Grid>

                      <Grid item xs={2} className="text-center hospitaliconholder color-darkblue">
                        <IconButton
                          edge="start"
                          className="menubtn"
                          color="inherit"
                          aria-label="menu"
                          onClick={this.handleSubmit}
                        >
                          <SendIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={0} className="gridcontainer">
                    <Grid item xs={8} className="zero">
                      <TextField
                        id="standard-helperText"
                        label=""
                        placeholder={t("Type here")}
                        helperText=""
                        value={this.state.content}
                        onChange={this.handleTextAreaChange}
                        style={{ 'margin-left': '10px' }}
                      />
                    </Grid>
                    <Grid item xs={2} className="zero text-center">
                      <Button
                        variant="contained"
                        component="label"
                        className="menubtn  chatgallerybutton"
                      >
                        <CameraAltIcon />
                        <input
                          onChange={this.handleImageAsFile}
                          type="file"
                          hidden
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={2} className="zero text-center">
                      <IconButton
                        edge="start"
                        className="menubtn"
                        color="inherit"
                        aria-label="menu"
                        onClick={this.handleSubmit}
                      >
                        <SendIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                )
              }
            </div>
          </TabPanel>

        </SwipeableViews>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    userObj: storeState.userDetail,
    chatConfig: storeState.chatConfig,
    fbuserObj: storeState.fbuserObj,
  };
};

const tServicesChatWindow = withTranslation()(ServicesChatWindow);
const ThemeChatWindow = withTheme(tServicesChatWindow);
const FinalThemeChatWindow = withStyles(useStyles)(ThemeChatWindow);
const routeChatWindow = withRouter(FinalThemeChatWindow);
export default connect(mapStateToProps, { setChatType })(routeChatWindow);
